<template>
  <b-card
    class="card-table"
    no-body
  >
    <b-card-body
      class="pb-0"
      @click="$router.push({name: 'dataManagementFolderView', params: {folderUuid: folder.folderGuid}})"
    >
      <b-card-title>
        <font-awesome-icon :icon="['fas', 'folder']" />
        {{ folder.folderName }}
      </b-card-title>
      <b-card-text>
        {{ folder.description }}
      </b-card-text>
    </b-card-body>

    <b-card-body
      v-if="canChangePermission(folder) ||canEdit(folder) || canDelete(folder)"
      class="action-wrapper"
    >
      <div class="d-flex justify-content-end ">
        <b-button
          v-if="canChangePermission(folder)"
          size="sm"
          variant="outline-secondary"
          :to="{name: 'dataManagementPermissions', params: {itemId: folder.folderGuid, type: permissionItemTypes.folder}}"
        >
          <font-awesome-icon :icon="['fas', 'key']" />
          Permissions
        </b-button>

        <b-button
          v-if="canEdit(folder)"
          size="sm"
          variant="outline-primary"
          class="ml-1"
          @click="showEditFolderModal(folder)"
        >
          <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          Edit
        </b-button>

        <b-button
          v-if="canDelete(folder)"
          size="sm"
          variant="outline-danger"
          class="ml-1"
          @click="deleteFolderFromList(folder)"
        >
          <font-awesome-icon :icon="['fas', 'trash']" />
          Delete
        </b-button>
      </div>
    </b-card-body>


    <!--    <b-dropdown class="actions-button" variant="link" no-caret right>-->
    <!--      <template v-slot:button-content>-->
    <!--        <b-button variant="link">-->
    <!--          <font-awesome-icon :icon="['fas', 'ellipsis-v']"/>-->
    <!--        </b-button>-->
    <!--      </template>-->
    <!--      <template>-->
    <!--        <b-dropdown-item :to="{name: 'dataManagementTableView',  params: {tableId: table.uuid}}">-->
    <!--          <font-awesome-icon-->
    <!--            :icon="['fas', 'eye']"/>-->
    <!--          View-->
    <!--        </b-dropdown-item>-->
    <!--        <b-dropdown-item :to="{name: 'dataManagementTablePermissions', params: {tableName: table.name}}">-->
    <!--          <font-awesome-icon :icon="['fas', 'key']"/>-->
    <!--          Manage Permissions-->
    <!--        </b-dropdown-item>-->
    <!--        <b-dropdown-item :to="{name: 'dataManagementBuilder.update',  params: {tableName: table.name}}">-->
    <!--          <font-awesome-icon :icon="['fas', 'pencil-alt']"/>-->
    <!--          Edit-->
    <!--        </b-dropdown-item>-->
    <!--        <b-dropdown-item @click="deleteTableCard(table)">-->
    <!--          <font-awesome-icon :icon="['fas', 'trash']"/>-->
    <!--          Delete-->
    <!--        </b-dropdown-item>-->
    <!--      </template>-->
    <!--    </b-dropdown>-->
  </b-card>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('dataManagement');

export default {
  name: 'FolderCard',
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      groups: [],
    };
  },
  computed: {
    ...mapState({
      permissionItemTypes: state => state.permissionItemTypes,
    }),
  },
  methods: {
    ...mapActions(['getFolders', 'getModules', 'showFolderModal', 'showModuleModal', 'addTable', 'deleteFolder', 'deleteModule', 'showFolderModal']),
    canChangePermission(folder) {
      return ['write'].includes(folder.currentUserPermission);
    },
    canEdit(folder) {
      return ['write'].includes(folder.currentUserPermission);
    },
    canDelete(folder) {
      return ['write'].includes(folder.currentUserPermission);
    },
    async deleteFolderFromList(folder) {
      if (folder.tables.length > 0) {
        return this.$toasted.error(`Folder has ${folder.tables.length} table(s) and can not be deleted`, {
          duration: TOASTER_DURATION,
        });
      }

      const confirm = await this.$confirm('Deleting folder...', `You are deleting folder "${folder.folderName}". Are you sure you want to continue?`);
      if (confirm) {
        const {success} = await this.deleteFolder(folder);
        if (success) {
          this.$toasted.success(`Folder "${folder.folderName}" was deleted`, {
            duration: TOASTER_DURATION,
          });
          this.getModules();
        }
      }
    },
    showEditFolderModal(data) {
      this.showFolderModal(data);
    },

  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style lang="scss" scoped>
    @import "../../../../../core/scss/variables";

    .card-table {
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
        border-radius: 0;
        height: 100%;
        width: 100%;
        min-height: 10rem;
        min-width: 16rem;

        &:hover {
            box-shadow: 0px 0px 0px 2px $primary;
        }

        .actions-button {
            position: absolute;
            right: 0;
            top: 0;
        }

        .actions-button-wrapper {
            text-align: center;
        }

    }

    .action-wrapper {
        flex-direction: column;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }
</style>
